import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import { AppStateService } from 'services/app/app-state.service';
import { RevisionService } from 'services/api/revision.service';
import {LadeanzeigeService} from '../../../../services/prozesse/ladeanzeige.service';
import {timer} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {PwaInstallationComponent} from '../../../obs.shared/dialog/pwaInstallation/pwaInstallation.component';
import {MitteilungenService} from '../../../obs.shared/componenten/mitteilungen/mitteilungen.service';
import {DialogVerwaltungsService} from '../../../obs.shared/dialog/services/dialogVerwaltungs.service';

@Component({
  selector: 'app-root',
  templateUrl: './wba.component.html',
  styleUrls: ['./wba.component.css'],
})

export class WbaComponent implements OnInit, OnDestroy {
  public kunde: boolean | object = false;
  public loadingOverlay: boolean = false
  public loadingOverlaySubscription

  @HostListener('document:visibilitychange', ['$event'])
  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.revisions_service.revision_kunde('kunde/get')
    } else {
      // TODO: Wenn die App im Hintergrund läuft
    }
  }

  constructor(
    public app_state_service: AppStateService,
    private revisions_service: RevisionService,
    private ladeanzeigenService: LadeanzeigeService,
    private mitteilungenService: MitteilungenService,
    private dialogService: DialogVerwaltungsService,
  ) {}

  ngOnInit() {
    if (!localStorage.getItem('readIosPwaInstall')) {
      const dialogRef = this.dialogService.standardDialog(
        'Installationsanleitung',
        PwaInstallationComponent,
        {}
      )
      dialogRef.afterClosed().subscribe(() => {
          if (this.mitteilungenService.pruefeMitteilungenObLeer()){
            this.mitteilungenService.dialogOpen()
          }
        }
      )
    }
    this.app_state_service.pruefeUpdateBeiRoute()
    this.loadingOverlaySubscription = this.ladeanzeigenService.ladeAnzeige.subscribe(status => {
      this.loadingOverlay = status;
    })
  }

  ngOnDestroy() {
    this.loadingOverlaySubscription.unsubscribe()
  }
}
